import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StockProjectionComponent } from './stock-projection.component';


const routes: Routes = [
  {
    path: '',
    component: StockProjectionComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StockProjectionRoutingModule { }
